export default function OutlineBarsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 5H3V7H21V5ZM15 9H3V11H15V9ZM3 13H21V15H3V13ZM15 17H3V19H15V17Z"
        fill="currentColor"
      />
    </svg>
  );
}
